// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"950":"d39f9b39","1355":"487be998","1848":"d87b77bf","2953":"4db2c489","6050":"d87b77bf","7899":"487be998"}[chunkId] + ".chunk.css";
};